/*
  Teedum (11/10/2026) : clés de ligne périmées dans le panier.
  Avec les réductions automatiques « Accessoires -5 % avec un meuble », Shopify change la clé de TOUTES les lignes concernées
  à chaque modification du panier. Un clic sur + / − avec une clé périmée (double clic rapide, retour arrière) renvoyait
  « Pas d'identifiant ou de paramètre de ligne valide ». Ce script refait la demande /cart/change avec la clé actuelle de la
  ligne (même variante). Chargé par layout/theme.liquid.
*/
(function () {
  if (window.teedumCartKeyFix) return;
  window.teedumCartKeyFix = true;
  var nativeFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var request = nativeFetch(input, init);
    if (url.indexOf('/cart/change') === -1 || !init || typeof init.body !== 'string') return request;
    return request.then(function (response) {
      if (response.ok || (response.status !== 400 && response.status !== 422)) return response;
      var payload;
      try { payload = JSON.parse(init.body); } catch (error) { return response; }
      if (!payload || typeof payload.id !== 'string' || payload.id.indexOf(':') === -1) return response;
      var variantId = parseInt(payload.id.split(':')[0], 10);
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return nativeFetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (cartResponse) { return cartResponse.json(); })
        .then(function (cart) {
          var lines = cart.items.filter(function (item) { return item.variant_id === variantId; });
          if (lines.length !== 1) return response;
          payload.id = lines[0].key;
          return nativeFetch(input, Object.assign({}, init, { body: JSON.stringify(payload) }));
        })
        .catch(function () { return response; });
    });
  };
})();
